import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { usePendingPartnerProjectSalesQuery } from "@/modules/packages/presentation/api/queries";
import type {
  OffsetPageQueryDTO,
  SortFieldDTO,
} from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { PartnerPendingLockFilter } from "../ui/PartnerPendingLockFilter";
import { PartnerPendingLockTable } from "../ui/PartnerPendingLockTable";

const DEFAULT_SORT: SortFieldDTO[] = [{ field: "createdAt", dir: "desc" }];

function normalizeSort(sort: OffsetPageQueryDTO["sort"]): SortFieldDTO[] {
  const first = sort?.[0];
  if (first && typeof first.field === "string") {
    return sort;
  }
  return DEFAULT_SORT;
}

export function PartnerPendingLockPage() {
  const nav = useNavigate({ from: "/app/sell/partner/pending-lock" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/sell/partner/pending-lock",
  });
  const sort = normalizeSort(search.sort);

  const list = usePendingPartnerProjectSalesQuery({
    offset: search.offset,
    limit: search.limit,
    sort,
    filters: search.filters,
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຂາຍ", to: "/app/sell" },
            { label: "Partner ລໍຖ້າ lock" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="font-semibold text-2xl tracking-tight">
              Partner ລໍຖ້າ lock
            </h1>
            <p className="text-muted-foreground text-sm">
              ລາຍການ draft / quoted ທີ່ຍັງບໍ່ເກັບເງິນ
            </p>
          </div>
        </div>

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <div className="px-4 pb-3">
            <PartnerPendingLockFilter />
          </div>

          <PartnerPendingLockTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={sort[0]?.field}
            sortOrder={sort[0]?.dir}
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onLockPricing={(id) =>
              nav({
                to: "/app/sell/partner/$id/lock-pricing",
                params: { id },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
